export const getOpenText = (index: number, isCompany: boolean) => {
  switch (index) {
    case 0:
      return 'Jeśli pojazd ma współwłaścicieli, dodaj ich również.';
    case 1:
      return isCompany
        ? 'Dodaj drugiego reprezentanta spółki'
        : 'Dodaj drugiego współwłaściciela';
    case 2:
      return isCompany
        ? 'Dodaj trzeciego reprezentanta spółki'
        : 'Dodaj trzeciego współwłaściciela';
    case 3:
      return isCompany
        ? 'Dodaj czwartego reprezentanta spółki'
        : 'Dodaj czwartego współwłaściciela';
    case 4:
      return isCompany
        ? 'Dodaj piątego reprezentanta spółki'
        : 'Dodaj piątego współwłaściciela';
    case 5:
      return isCompany
        ? 'Dodaj szóstego reprezentanta spółki'
        : 'Dodaj szóstego współwłaściciela';
    case 6:
      return isCompany
        ? 'Dodaj siódmego reprezentanta spółki'
        : 'Dodaj siódmego współwłaściciela';
    case 7:
      return isCompany
        ? 'Dodaj ósmego reprezentanta spółki'
        : 'Dodaj ósmego współwłaściciela';
    case 8:
      return isCompany
        ? 'Dodaj dziewiątego reprezentanta spółki'
        : 'Dodaj dziewiątego współwłaściciela';
    default:
      return '';
  }
};
